import React from "react";

import celulares from '../../../assets/img/celulares-passcoopeuch.png';
import btnGooglePlay from '../../../assets/img/btn-googleplay.png';
import btnAppStore from '../../../assets/img/btn-appstore.png';
import warningImg from '../../../assets/img/icon-warning.svg';
import ContenedorSinFactor from './styles';

import "./styles.js";

const SinFactor = () => {
  return (
    <>
      <ContenedorSinFactor className="contenedor-error">
        <div className="contenedor-informacion">
          <img src={warningImg} alt="sin-factor-img" />
          <hgroup>
            <p>Estimado Socio, no cuentas con factores de seguridad para autorizar tu compra.</p>
          </hgroup>
        </div>
        <hr />
        <div className="descargar-app">
        <hgroup className="split">
          <h2>Descarga y usa PassCoopeuch</h2>
          <p>Te invitamos a descargar PassCoopeuch para que puedas autorizar tus transacciones solo con tu móvil de forma fácil, rápida y segura.</p>
          </hgroup>
          <figure>
            <img src={celulares} alt="descargar-app" />
          </figure>
          <p>Descárgarla desde tu teléfono móvil</p>
          <figure className="btn-apps">
            <img src={btnGooglePlay} alt="Google Play"/>
            <img src={btnAppStore} alt="App Store" />
          </figure>
        </div>
      </ContenedorSinFactor>
    </>
  );
}

export default SinFactor;
